import { downloadCSV } from 'react-admin';

export default (csv: string, filename: string): void => {
  const isIOS = (): boolean => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return false;
    }
    const ua = navigator.userAgent;
    const platform = navigator.platform;
    const isIPadOS = platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    const isIOSDevice = /iPhone|iPad|iPod/.test(ua);
    return isIPadOS || isIOSDevice;
  };

  if (isIOS()) {
    const fakeLink = document.createElement('a');
    fakeLink.style.display = 'none';
    document.body.appendChild(fakeLink);

    const blob = new Blob([csv], { type: 'application/octet-stream' });
    fakeLink.setAttribute('href', URL.createObjectURL(blob));
    fakeLink.setAttribute('download', `${filename}.csv`);
    fakeLink.click();
  } else {
    downloadCSV(csv, filename);
  }
};
